import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function ProductImage({
  name,
  images = [],
  thumbImage,
  anmStyle,
}) {
  const [hovered, setHovered] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    let timer;
    if (hovered && images.length > 1) {
      timer = setInterval(() => {
        setImageIndex((prev) => (prev + 1) % images.length);
      }, 2000);
    } else {
      setImageIndex(0);
    }
    return () => clearInterval(timer);
  }, [hovered, images]);

  const activeImage =
    hovered && images.length ? images[imageIndex] : thumbImage;

  return (
    <motion.div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="
        relative w-full 
        flex items-center justify-center
        overflow-hidden
        bg-white
        aspect-[3/4]
        sm:aspect-[3/4]
        md:aspect-[3/4]
      "
    >
      <AnimatePresence mode="wait">
        {activeImage && (
          <motion.img
            key={activeImage}
            src={activeImage}
            alt={name}
            className="
              w-full h-full
              object-contain    
            "
            initial={
              anmStyle === "fade"
                ? { opacity: 0 }
                : { x: 40, opacity: 0 }
            }
            animate={{ x: 0, opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
          />
        )}
      </AnimatePresence>
    </motion.div>
  );
}
